import { useEffect, useState } from 'react';
import './TrainingCard.scss';
import SvgIcons from '../../services/SvgIcons';
import CustomBtn from '../CustomBtn/CustomBtn';
import { baseURL } from '../../services/config';
import ProgressBar from '../ProgressBar/ProgressBar';
import BackgroundImageWithSkeleton from '../BackgroundImageWithSkeleton/BackgroundImageWithSkeleton';
import Skeleton from '../Skeleton/Skeleton';
import { safeHtml } from '../../services/helpers';

export default function TrainingCard({ training, isSkeleton = false }) {

    // Calculer les statistiques de la formation
    const getTrainingStats = () => {
        if (!training.Chapitres) return { chaptersCount: 0, lessonsCount: 0 };
        
        const chaptersCount = training.Chapitres.length;
        const lessonsCount = training.Chapitres.reduce((total, chapter) => {
            return total + (chapter.Lecons ? chapter.Lecons.length : 0);
        }, 0);
        
        return { chaptersCount, lessonsCount };
    };

    const { chaptersCount, lessonsCount } = getTrainingStats();

    return (
        <div className='training-card'>
            {
                training.PhotoCarte ?
                    <BackgroundImageWithSkeleton
                        picture={training.PhotoCarte}
                        width={'100%'}
                        height={'250px'}
                        positionMobile='static'
                        positionDesktop='static'
                        borderRadius='10px 10px 0 0'
                    />
                    :
                    <Skeleton
                        width="100%"
                        height="250px"
                        borderRadius="10px 10px 0 0"
                        bkgColor="#EEE6DB"
                        animColor="#F5F0ED"
                    />
            }
            {training.userProgress && (
                <span
                    className='training-card__state'
                    style={{
                        backgroundColor: training.userProgress.progressPercentage > 0 && training.userProgress.progressPercentage < 100 ? '#0073CC'
                            : training.userProgress.progressPercentage === 100 ? '#66CC66'
                            : '#FF6666',
                    }}
                >
                    {training.userProgress.progressPercentage > 0 && training.userProgress.progressPercentage < 100 ? 'En cours' 
                        : training.userProgress.progressPercentage === 100 ? 'Terminé' 
                        : 'Non démarré'}
                </span>
            )}
            <div className='training-card__content'>
                <div>
                    {
                        training.Titre ?
                            <h2 className='training-card__title'>{training.Titre}</h2>
                            :
                            <Skeleton
                                width='100%'
                                height='40px'
                                borderRadius='3px'
                                bkgColor='#EEE6DB'
                                animColor='#F5F0ED'
                            />
                    }
                    {
                        training.Auteur ?
                            <span className='training-card__author'>{training.Auteur}</span>
                            :
                            <Skeleton
                                width='60%'
                                height='24px'
                                borderRadius='3px'
                                bkgColor='#EEE6DB'
                                animColor='#F5F0ED'
                                margin='10px 0'
                            />
                    }
                    {
                        training.Objectif ?
                            <div className="training-card__goal" dangerouslySetInnerHTML={safeHtml(training.Objectif)} />
                            :
                            <Skeleton
                                width='100%'
                                height='72px'
                                borderRadius='3px'
                                bkgColor='#EEE6DB'
                                animColor='#F5F0ED'
                            />
                    }
                </div>
                <div className='training-card__progressAndBtn'>
                    <div className='training-card__progress'>
                        {
                            training.id && training.userProgress ?
                                <ProgressBar progress={training.userProgress.progressPercentage || 0} />
                                :
                                <Skeleton
                                    width='100%'
                                    height='24px'
                                    borderRadius='12px'
                                    bkgColor='#EEE6DB'
                                    animColor='#F5F0ED'
                                    margin='1.5rem 0'
                                />
                        }
                    </div>
                    <div className='training-card__chapters_nb_btn'>
                        <div className='training-card__chapters_lessons_nb_container'>
                            <SvgIcons
                                name="document"
                                width="40"
                                height="40"
                                color="#6D4F47"
                            />
                            <div className='training-card__chapters_lessons_nb'>
                                {
                                    training.chaptersCount > 0 ?
                                        <p className='training-card__chapters_nb'>
                                            {training.chaptersCount + (training.chaptersCount > 1 ? ' chapitres' : ' chapitre')}
                                        </p>
                                        :
                                        <Skeleton
                                            width='100%'
                                            height='16px'
                                            borderRadius='3px'
                                            bkgColor='#EEE6DB'
                                            animColor='#F5F0ED'
                                            margin={'3px 0'}
                                        />
                                }
                                {
                                    training.lessonsCount > 0 ?
                                        <p className='training-card__lessons_nb'>
                                            {training.lessonsCount + (training.lessonsCount > 1 ? ' leçons' : ' leçon')}
                                        </p>
                                        :
                                        <Skeleton
                                            width='100%'
                                            height='16px'
                                            borderRadius='3px'
                                            bkgColor='#EEE6DB'
                                            animColor='#F5F0ED'
                                            margin={'3px 0'}
                                        />
                                }
                            </div>
                        </div>
                        {
                            training.id ?
                                <CustomBtn
                                    type={'internal'}
                                    title={"Accéder"}
                                    link={'/mes-formations/' + training.slug}
                                    state={{ title: training.Titre, titlePicture: training.Photo }}
                                    bkg_color={'#361215'}
                                    bkg_color_hover={'#EEE6DB'}
                                    text_color={'#EEE6DB'}
                                    text_color_hover={'#361215'}
                                    border_color={'#361215'}
                                    border_color_hover={'#361215'}
                                    font_family={'Playfair Display, serif'}
                                    font_size={'18px'}
                                    border_radius={'3px'}
                                    width={'120px'}
                                    height={'42px'}
                                />
                                :
                                <Skeleton
                                    width='120px'
                                    height='42px'
                                    borderRadius='3px'
                                    bkgColor='#EEE6DB'
                                    animColor='#F5F0ED'
                                    margin={'5px 0'}
                                />
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}